import React from 'react';

import { useSelector } from 'react-redux';

import { Button } from '@waglabs/button-next';
import {
  ChevronLeftIcon,
} from '@waglabs/icons';
import { Typography } from '@waglabs/typography';
import { Box } from '@waglabs/box-next';
import { Flex } from '@waglabs/flex-next';

import { LoginByPasswordFormStep } from './LoginByPasswordFormStep';
import { LoginByCodeFormStep } from './LoginByCodeFormStep';

import {
  getPreferredMethod,
  getAllowedMethodsExcludingPreferredMethod,
} from '../../../../../../reducers/auth/auth.selector';
import { Auth } from '../../../../../../constants';

import type { UseStepperReturnType } from '../../../../../../hooks/useStepper';

type LoginByPhoneFormStep2Props = UseStepperReturnType & {};

const buttonActionMapping = {
  [Auth.AllowedMethods.CodeSMS]: {
    stepName: LoginByCodeFormStep.name,
    text: 'Text me a sign in code',
  },
  [Auth.AllowedMethods.Password]: {
    stepName: LoginByPasswordFormStep.name,
    text: 'Sign in via password',
  },
};

export const LoginByPhoneFormStep2 = ({
  handleBack,
  handleNext,
  setMeta,
}: LoginByPhoneFormStep2Props) => {
  const primaryMethod = useSelector(getPreferredMethod);
  const primaryCTA = buttonActionMapping[primaryMethod];
  const secondaryMethods = useSelector(
    getAllowedMethodsExcludingPreferredMethod,
  );

  return (
    <>
      <Flex
        height="24px"
        alignItems="center"
        onClick={() => {
          handleBack();
        }}
        hover
      >
        <ChevronLeftIcon
          color="wagGreen"
          cursor="pointer"
        />
        <Typography
          m={0}
          color="wagGreen"
          hover
        >
          Back
        </Typography>
      </Flex>
      <Box
        display="grid"
        gridTemplateColumns={['1fr']}
        gridGap="8px"
        px={['unset', '72px']}
        py="24px"
      >
        <Button
          variant="contained"
          onClick={() => {
            setMeta({
              stepName: primaryCTA.stepName,
            });
            handleNext();
          }}
        >
          {primaryCTA.text}
        </Button>
        {/* secondary cta */}
        {secondaryMethods.map(secondaryMethod => (
          <Button
            key={buttonActionMapping[secondaryMethod].text}
            variant="text"
            onClick={() => {
              setMeta({
                stepName: buttonActionMapping[secondaryMethod].stepName,
              });
              handleNext();
            }}
          >
            {buttonActionMapping[secondaryMethod].text}
          </Button>
        ))}
      </Box>
    </>
  );
};
